import { TemplateData, TemplateParams } from '.';

const calendarEventAccessRequestDeny = ({
  defaultPlaceholders,
  messages,
  serverConfig
}: TemplateParams): TemplateData => ({
  category: 'calendar-events',
  email: {
    buttonEnabled: true,
    buttonLink: '{{siteUrl}}',
    buttonText: messages.authSignIn,
    content: `
      <p>
        ${messages.calendarEventAccessRequestDeny}
      </p>
      <p>
        {{optionalMessage}}
      </p>`,
    contentAfterButton: `
      <p>
        ${messages.emailSignatureText}
      </p>`,
    heading: messages.emailGreeting,
    footnote: `${messages.emailContentClarification} {{contactEmail}}`,
    subject: `{{siteName}}: ${messages.calendarEventAccessRequestDenied}`
  },
  placeholders: {
    eventTitle: {
      label: messages.calendarEventTitle,
      example: 'Test event'
    },
    optionalMessage: {
      label: messages.commonMessageFromAdmin,
      example: 'We could not get you a place.'
    },
    ...defaultPlaceholders
  },
  title: messages.calendarEventAccessRequestDenied
});

export default calendarEventAccessRequestDeny;
